import React from "react"
import styled from "@emotion/styled"
import Carousel, { CarouselProps } from "react-multi-carousel"
import { md } from "../../styles/mediaQuery"

export const TheCarousel = ({ className, children, ...props }: Props) => {
  return (
    <TheCarouselWrapper className={className}>
      <Carousel {...props}>{children}</Carousel>
    </TheCarouselWrapper>
  )
}

interface Props extends CarouselProps {
  children: React.ReactNode
  className?: string
}

export const TheCarouselWrapper = styled.div`
  .react-multi-carousel-list {
    margin-bottom: -25px;
    margin-left: -25px;
    display: flex;
    align-items: center;
    overflow: hidden;
    position: relative;

    ${md} {
      margin-bottom: -14px;
      margin-left: -14px;
    }
  }

  .react-multi-carousel-track {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
    position: relative;
    transform-style: preserve-3d;
    backface-visibility: hidden;
    will-change: transform, transition;
  }

  .react-multiple-carousel__arrow {
    position: absolute;
    outline: 0;
    transition: all 0.5s;
    border-radius: 35px;
    z-index: 1000;
    border: 0;
    background: rgba(0, 0, 0, 0.5);
    min-width: 43px;
    min-height: 43px;
    opacity: 1;
    cursor: pointer;
  }

  .react-multiple-carousel__arrow:hover {
    background: rgba(0, 0, 0, 0.8);
  }

  .react-multiple-carousel__arrow::before {
    font-size: 22px;
    color: #fff;
    line-height: 22px;
    display: block;
    text-align: center;
    z-index: 2;
    position: relative;
  }

  .react-multiple-carousel__arrow--left {
    left: calc(4% + 1px);
  }

  .react-multiple-carousel__arrow--left::before {
    content: "◄";
  }

  .react-multiple-carousel__arrow--right {
    right: calc(4% + 1px);
  }

  .react-multiple-carousel__arrow--right::before {
    content: "►";
  }

  .react-multi-carousel-dot-list {
    position: absolute;
    bottom: 0;
    display: flex;
    left: 0;
    right: 0;
    justify-content: center;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
  }

  .react-multi-carousel-dot button {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    opacity: 1;
    box-shadow: none;
    transition: background 0.5s;
    border-width: 2px;
    border-style: solid;
    border-color: grey;
    padding: 0;
    margin: 0 6px 0 0;
    outline: 0;
    cursor: pointer;
  }

  .react-multi-carousel-dot button:hover:active {
    background: #080808;
  }

  .react-multi-carousel-dot--active button {
    background: #080808;
  }

  .react-multi-carousel-item {
    transform-style: preserve-3d;
    backface-visibility: hidden;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .react-multi-carousel-item {
      flex-shrink: 0 !important;
    }

    .react-multi-carousel-track {
      overflow: visible !important;
    }
  }
`
